/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { IGetCredentialsListProps } from "./components";
const is = require("is_js");

const SERVICE_NAME = "HoldersListService";
const log: any = LoggerModule.getInstance();

export class HoldersListPageService {
  private static instance: HoldersListPageService;
  private vapp: VApplication;
  private criteria: any;
  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public static getInstance(props: any = {}): HoldersListPageService {
    if (!HoldersListPageService.instance) {
      HoldersListPageService.instance = new HoldersListPageService(props);
    }
    return HoldersListPageService.instance;
  }
  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent(args: IGetCredentialsListProps) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }
    //Header Props
    compProps = await agent.getHeaderProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    // //Main Props
    // compProps = await agent.getMainSectionProps({});
    // if (compProps) {
    //   content = { ...content, ...compProps };
    // }

    //Feature Section Props
    compProps = await agent.getFeatureSectionProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Footer Props
    compProps = await agent.getFooterProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPolicyList(args:any){
     //policy List Props
     const agent = getAgent();
    return await agent?.getAppCardListProps({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });
  }

  public async updateKyc(args: any) {
    const agent = getAgent();
    return agent?.getUpdateKyc(args);
  }
}
